import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { useContext } from "react";
import { prefixClassname } from "../styles/index.js";
import NumberKeyboardContext from "./number-keyboard.context.js";
function NumberKeyboardButton(props) {
    const { className, type = "hide", children, onClick, ...restProps } = props;
    const { onKeyPress } = useContext(NumberKeyboardContext);
    function handleClick(event) {
        onClick?.(event);
        if (type === "hide") {
            onKeyPress?.(children, "keyboard-hide");
        }
    }
    return (React.createElement(View, { className: classNames({
            [prefixClassname("number-keyboard__hide")]: type === "hide",
        }, className), children: children, onClick: handleClick, ...restProps }));
}
export default NumberKeyboardButton;
